import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { Plus } from 'lucide-react'
import type { ArtefactTemplate } from '../../../types/artefact-templates'

interface ManagerHeaderProps {
  onCreate: () => void
  t: TFunction<'cases'>
}

export function ManagerHeader({ onCreate, t }: ManagerHeaderProps): ReactElement {
  return (
    <div className="items-centre flex justify-between">
      <div>
        <h3 className="font-heading text-lg font-semibold text-slate-800 dark:text-slate-100">
          {t('collections.artefactTemplates.title')}
        </h3>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          {t('collections.artefactTemplates.description')}
        </p>
      </div>
      <button
        onClick={onCreate}
        className="items-centre flex gap-2 rounded-lg bg-[#4e5e82] px-4 py-2 text-sm font-medium text-white hover:bg-[#5c6e94] focus:ring-2 focus:ring-[#4e5e82] focus:outline-none"
      >
        <Plus className="h-4 w-4" />
        {t('collections.artefactTemplates.createTemplate')}
      </button>
    </div>
  )
}

interface TemplatesSectionProps {
  heading: string
  templates: ArtefactTemplate[]
  emptyMessage?: string
  renderItem: (template: ArtefactTemplate) => ReactElement
}

export function TemplatesSection({
  heading,
  templates,
  emptyMessage,
  renderItem,
}: TemplatesSectionProps): ReactElement {
  return (
    <div className="space-y-3">
      <h4 className="text-sm font-medium tracking-wider text-slate-500 uppercase dark:text-slate-400">
        {heading}
      </h4>
      {templates.length === 0 && emptyMessage && (
        <p className="text-sm text-slate-400 italic dark:text-slate-500">{emptyMessage}</p>
      )}
      <div className="grid gap-3">{templates.map((template) => renderItem(template))}</div>
    </div>
  )
}

export function ManagerLoading(): ReactElement {
  return (
    <div className="items-centre justify-centre flex p-8" role="status">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-[#4e5e82] border-t-transparent" />
    </div>
  )
}
